<template>
  <v-container>
    <h1>About Vie Monie TH</h1>
    <p>
      Vie Monie is a web-app, used in a group trip to calculate the summary expense 
      that each members have to pay others, when someone pay for the group.
    </p>

    <section v-for="(version, index) in updateHistory" :key="index" class="mt-5">
      <div>
        <span class="text-h6">{{ version.version }}</span>
        <span class="caption"> ({{ version.date }})</span>
      </div>

      <div v-for="(section, sectionIndex) in version.sections" :key="sectionIndex">
        <u>{{ section.title }}</u>
        <ul>
          <li v-for="(item, itemIndex) in section.items" :key="itemIndex" :id="item.id" v-html="item.text"></li>
        </ul>
      </div>
    </section>

    <section class="mt-5">
      <div>
        <span class="text-h5">What's next?</span>
      </div>
      <ul>
        <li>Authen Account, Login with Google</li>
        <li>Make group and transaction editable</li>
      </ul>
    </section>

    <v-divider class="mt-12"></v-divider>

    <section class="my-3">
      This project takes only 5 days to build (core function, until v1.2), if you find any bugs contact me at
      <a href="mailto:chouwat.c@ku.th">chouwat.c@ku.th</a> 
    </section>
  </v-container>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      updateHistory: [
        {
          version: 'Version 1.0',
          date: '17/02/2022',
          sections: [
            {
              title: 'Group',
              items: [
                { text: 'User can create a group (including group\'s name and group\'s members)' },
                { text: 'User can share the group by using Link URL or Group ID' },
                { text: 'User can see list of their previous group (and can delete it)' },
                { text: 'In Group, user can filter their name to highlight their payment' }
              ]
            },
            {
              title: 'Transaction',
              items: [
                { text: 'User can add an item (item\'s name, item\'s price, who paid and how much, who rent)' },
                { text: 'Equally paid assumption is used to calculate the Renter\'s cost' },
                { text: 'User can see each transaction (item\'s name, item\'s price, who paid and how much, who rent and how much)' },
                { text: 'User can mark that transaction as paid / unpaid' },
                { 
                  id: 'basic-reducer',
                  text: 'Basic cost reducer are used.<br>The goal is to eliminate reciprocal debts between people wherever possible.<br>Ex: Say, <b>A pay B for 5$</b> and <b>B pay A for 3$</b>, In summary user will see <b>B has to pay A for 2$</b>'
                }
              ]
            }
          ]
        },
        {
          version: 'Version 1.1',
          date: '19/02/2022',
          sections: [
            {
              title: 'Group',
              items: [
                { text: 'User can share the group by using QR code' },
                { text: 'User can enable Graph Topology for reducing summary cost' }
              ]
            },
            {
              title: 'Transaction',
              items: [
                {
                  id: 'graph-topology-reducer',
                  text: 'Support <b>Graph Topology</b> for reducing summary cost.<br>The goal is to minimize the number of transactions by <b>removing graph cycles</b> which represent redundant exchanges of money between members.<br>Ex: Say,<ul><li><b>A pay B for 5$</b></li><li><b>B pay C for 3$</b></li><li><b>C pay A for 4$</b></li></ul>In summary user will see<ul><li><b>B has to pay A for 2$</b></li><li><b>A has to pay C for 1$</b></li></ul>'
                }
              ]
            }
          ]
        },
        {
          version: 'Version 1.2',
          date: '21/02/2022',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'Improve UI/UX when using Graph Topology' },
                { text: 'Show a timestamp of when that transaction was created' }
              ]
            },
            {
              title: 'Others',
              items: [
                { text: 'Major update, refine codes, using Class, OOP' },
                { text: 'Use firebase firestore sub-collection' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.3',
          date: '27/02/2022',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'When user pay more than item\'s cost, app will update item\'s cost to match' }
              ]
            },
            {
              title: 'Others',
              items: [
                { text: 'Support Multi-Language (TH/EN), using i18n' },
                { text: 'Add App\'s dialog UI' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.3.1',
          date: '08/03/2023',
          sections: [
            {
              title: 'Others',
              items: [
                { text: 'Add money usage\'s proportion and Total money usage (from renters) in summary' },
                { text: 'Show total amount that user has to pay in Summary.' },
                { text: 'When user uses name filtering, it will hide transactions that does not relate to the user.' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.4',
          date: '22/12/2024',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'Add slip image uploader for each transaction' },
                { text: 'Support custom split for renters' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.4.1',
          date: '25/12/2024',
          sections: [
            {
              title: 'Others',
              items: [
                { text: 'Major UI update, add modern box shadow, border radius, and UI color' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.5',
          date: '12/01/2025',
          sections: [
            {
              title: 'Transaction',
              items: [
                {
                  id: 'net-balance-reducer',
                  text: 'Support <b>Net Banlances Reducer Mode</b> for reducing summary cost,<br>ex: Say,<ul><li><b>A pay B for 3$</b></li><li><b>B pay C for 5$</b></li></ul>In summary user will see<ul><li><b>A has to pay C for 3$</b></li><li><b>B has to pay C for 2$</b></li></ul>'
                },
                {
                  text: 'This mode minimizes transactions by ensuring <b>no member ends up as both a creditor and a debtor simultaneously</b>. It calculates each member\'s net balance (incoming minus outgoing amounts) and settles those balances directly, <b>avoiding unnecessary intermediate transactions</b>.'
                }
              ]
            }
          ]
        },
        {
          version: 'Version 1.5.1',
          date: '17/01/2025',
          sections: [
            {
              title: 'Others',
              items: [
                { text: 'Add member payment info section in Group View, to show bank account number, bank name, and account holder name' },
                { text: 'Add Member Setting Dialog to set bank infomation' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.5.2',
          date: '07/04/2025',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'New "payment" transaction UI with improved data storage structure for "Cost Reducing Mode = Net Balances" only.' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.5.3',
          date: '04/01/2026',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'Add renter table UI for "Cost Reducing Mode = Net Balances" only.' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.5.3a',
          date: '08/01/2026',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'Update UI for better mobile compatibility (UI, padding, font size, etc.)' }
              ]
            }
          ]
        },
        {
          version: 'Version 1.6',
          date: '03/08/2026',
          sections: [
            {
              title: 'Transaction',
              items: [
                { text: 'Collapsed renter table UI (when not showing raw cost): group renters with the same amount into one row with name chips' },
                { text: 'Stacked amount shows as "{count} × {amount}" when multiple renters share the same cost' },
                { text: 'Show "(Payer)" for a renter who is also the payer and has no remaining cost' },
                { text: 'Highlight the current user\'s name chip in the renter table' }
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>
